const list = [
    {
        "drawCode": "98332",
        "drawAt": "2022-06-27 11:30:00",
        "isNight": false,
        "title": null,
        "dayOfWeek": "Thứ hai",
        "header": [
            "Thừa T. Huế",
            "Phú Yên",
            "Ninh Thuận"
        ],
        "subHeader": [
            "2022-06-27 11:30:00",
            "XSTTH",
            "XSPY",
            "XSNT"
        ],
        "results": [
            {
                "code": "Giải tám",
                "items": [
                    [
                        "17"
                    ],
                    [
                        "53",
                    ],
                    [
                        "44"
                    ],
                ]
            },
            {
                "code": "Giải bảy",
                "items": [
                    ["604"],
                    ["242"],
                    ["290"]
                ]
            },
            {
                "code": "Giải sáu",
                "items": [
                    [
                        "8950",
                        "3547",
                        "0778"
                    ],
                    [
                        "0344",
                        "2282",
                        "3148"
                    ],
                    [
                        "1136",
                        "4401",
                        "7113"
                    ]
                ]
            },
            {
                "code": "Giải năm",
                "items": [
                    ["2619"],
                    ["7811"],
                    ["5762"]
                ]
            },
            {
                "code": "Giải tư",
                "items": [
                    [
                        "78929",
                        "13807",
                        "90273",
                        "99261",
                        "95862",
                        "26773"
                    ],

                    [
                        "29107",
                        "75821",
                        "01547",
                        "73435",
                        "49021",
                        "93508"
                    ],

                    [
                        "78827",
                        "72351",
                        "55345",
                        "12044",
                        "46708",
                        "55446"
                    ],

                ]
            },
            {
                "code": "Giải ba",
                "items": [
                    [
                        "93356",
                        "59863",
                    ],
                    [
                        "59284",
                        "00045",
                    ],
                    [
                        "59284",
                        "66665",
                    ],
                ]
            },
            {
                "code": "Giải nhì",
                "items": [
                    ["53155"],
                    ["72085"],
                    ["75766"]
                ]
            },
            {
                "code": "Giải nhất",
                "items": [
                    ["60989"],
                    ["71172"],
                    ["60241"]
                ]
            },
            {
                "code": "Giải Đặc Biệt",
                "items": [
                    ["268610"],
                    ["044470"],
                    ["467989"]
                ]
            }
        ]
    },
    {
        "drawCode": "98333",
        "drawAt": "2022-06-27 13:30:00",
        "isNight": false,
        "title": null,
        "dayOfWeek": "Thứ hai",
        "header": [
            "Thừa T. Huế",
            "Phú Yên",
            "Ninh Thuận"
        ],
        "subHeader": [
            "2022-06-27 13:30:00",
            "XSTTH",
            "XSPY",
            "XSNT"
        ],
        "results": [
            {
                "code": "Giải tám",
                "items": [
                    [
                        "17"
                    ],
                    [
                        "53",
                    ],
                    [
                        "44"
                    ],
                ]
            },
            {
                "code": "Giải bảy",
                "items": [
                    ["604"],
                    ["242"],
                    ["290"]
                ]
            },
            {
                "code": "Giải sáu",
                "items": [
                    [
                        "8950",
                        "3547",
                        "0778"
                    ],
                    [
                        "0344",
                        "2282",
                        "3148"
                    ],
                    [
                        "1136",
                        "4401",
                        "7113"
                    ]
                ]
            },
            {
                "code": "Giải năm",
                "items": [
                    ["2619"],
                    ["7811"],
                    ["5762"]
                ]
            },
            {
                "code": "Giải tư",
                "items": [
                    [
                        "78929",
                        "13807",
                        "90273",
                        "99261",
                        "95862",
                        "26773"
                    ],

                    [
                        "29107",
                        "75821",
                        "01547",
                        "73435",
                        "49021",
                        "93508"
                    ],

                    [
                        "78827",
                        "72351",
                        "55345",
                        "12044",
                        "46708",
                        "55446"
                    ],

                ]
            },
            {
                "code": "Giải ba",
                "items": [
                    [
                        "93356",
                        "59863",
                    ],
                    [
                        "59284",
                        "00045",
                    ],
                    [
                        "59284",
                        "66665",
                    ],
                ]
            },
            {
                "code": "Giải nhì",
                "items": [
                    ["53155"],
                    ["72085"],
                    ["75766"]
                ]
            },
            {
                "code": "Giải nhất",
                "items": [
                    ["60989"],
                    ["71172"],
                    ["60241"]
                ]
            },
            {
                "code": "Giải Đặc Biệt",
                "items": [
                    ["268610"],
                    ["044470"],
                    ["467989"]
                ]
            }
        ]
    },
    {
        "drawCode": "98334",
        "drawAt": "2022-06-27 18:30:00",
        "isNight": false,
        "title": null,
        "dayOfWeek": "Thứ hai",
        "header": [
            "Thừa T. Huế",
            "Phú Yên",
            "Ninh Thuận"
        ],
        "subHeader": [
            "2022-06-27 18:30:00",
            "XSTTH",
            "XSPY",
            "XSNT"
        ],
        "results": [
            {
                "code": "Giải tám",
                "items": [
                    [
                        "17"
                    ],
                    [
                        "53",
                    ],
                    [
                        "44"
                    ],
                ]
            },
            {
                "code": "Giải bảy",
                "items": [
                    ["604"],
                    ["242"],
                    ["290"]
                ]
            },
            {
                "code": "Giải sáu",
                "items": [
                    [
                        "8950",
                        "3547",
                        "0778"
                    ],
                    [
                        "0344",
                        "2282",
                        "3148"
                    ],
                    [
                        "1136",
                        "4401",
                        "7113"
                    ]
                ]
            },
            {
                "code": "Giải năm",
                "items": [
                    ["2619"],
                    ["7811"],
                    ["5762"]
                ]
            },
            {
                "code": "Giải tư",
                "items": [
                    [
                        "78929",
                        "13807",
                        "90273",
                        "99261",
                        "95862",
                        "26773"
                    ],

                    [
                        "29107",
                        "75821",
                        "01547",
                        "73435",
                        "49021",
                        "93508"
                    ],

                    [
                        "78827",
                        "72351",
                        "55345",
                        "12044",
                        "46708",
                        "55446"
                    ],

                ]
            },
            {
                "code": "Giải ba",
                "items": [
                    [
                        "93356",
                        "59863",
                    ],
                    [
                        "59284",
                        "00045",
                    ],
                    [
                        "59284",
                        "66665",
                    ],
                ]
            },
            {
                "code": "Giải nhì",
                "items": [
                    ["53155"],
                    ["72085"],
                    ["75766"]
                ]
            },
            {
                "code": "Giải nhất",
                "items": [
                    ["60989"],
                    ["71172"],
                    ["60241"]
                ]
            },
            {
                "code": "Giải Đặc Biệt",
                "items": [
                    ["268610"],
                    ["044470"],
                    ["467989"]
                ]
            }
        ]
    },

    {
        "drawCode": "98332",
        "drawAt": "2022-06-27 18:30:00",
        "isNight": true,
        "title": ["15SP", "5SP", "11SP", "14SP", "13SP", "14SP"],
        "dayOfWeek": "Thứ hai",
        "header": null,
        "subHeader": null,
        "results": [
            {
                "code": "Giải ĐB",
                "items": [
                    ["05748"]
                ]
            },
            {
                "code": "Giải nhất",
                "items": [
                    ["95395"]
                ]
            },
            {
                "code": "Giải nhì",
                "items": [
                    ["17438"],
                    ["98200"]
                ]
            },
            {
                "code": "Giải ba",
                "items": [
                    ["30927", "73311"],
                    ["53045", "67538"],
                    [ "97479", "69781"],
                ]
            },
            {
                "code": "Giải tư",
                "items": [
                    ["3589", "8580"],
                    ["3968", "4745"]

                ]
            },
            {
                "code": "Giải năm",
                "items": [
                    ["8403","1300"],
                    ["1815","6176"],
                    ["1439", "2874"]
                ]
            },
            {
                "code": "Giải sáu",
                "items": [
                    ["687"],
                    ["530"],
                    ["804"]
                ]
            },
            {
                "code": "Giải sáu",
                "items": [
                    ["92"],
                    ["32"],
                    ["45"],
                    ["20"]
                ]
            }
        ]
    }
];

export default list;

export const drawingV2 = {
    results: [],
    rightResults: [],
    slotResults: []
}
